/* KBW video — click to play.

   Nothing is requested from YouTube or Vimeo until the visitor asks for it.
   Until then the box holds a poster image and a play button, which costs one
   image instead of the several hundred kilobytes and the third-party cookies
   an embedded player pulls in on page load. The previous theme did the same;
   it is worth keeping.

   The embed URL is built in Liquid, where the video id already is, so this
   file never has to know one provider's URL shape from another's.

   Markup contract:
     [data-kbw-video]           the box, carrying data-embed and data-title
     [data-kbw-video-trigger]   the button that swaps the poster for the player
*/

(function () {
  'use strict';

  function play(root) {
    var frame = document.createElement('iframe');
    frame.className = 'kbw-vp__frame';
    frame.src = root.dataset.embed;
    frame.title = root.dataset.title || 'Video';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame.setAttribute('frameborder', '0');

    root.textContent = '';
    root.appendChild(frame);

    /* The button that had keyboard focus has just been removed. Without this,
       focus falls back to the top of the document and someone tabbing through
       the page loses their place at the moment they start the video. */
    frame.focus();
  }

  function setup(root) {
    if (root.dataset.kbwVideoReady === '1') return;

    var trigger = root.querySelector('[data-kbw-video-trigger]');
    if (!trigger || !root.dataset.embed) return;

    root.dataset.kbwVideoReady = '1';
    trigger.addEventListener('click', function () {
      play(root);
    });
  }

  function setupAll() {
    var roots = document.querySelectorAll('[data-kbw-video]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  // The theme editor re-renders a section in place.
  document.addEventListener('shopify:section:load', setupAll);
})();
